import { UserPageCriteria } from '../model/user-page-criteria';
import { User } from '../model/user';

export namespace UserActions {
  const prefix = '[User]';

  export class GetPage {
    static readonly type = `${prefix} Get page`;

    constructor(readonly criteria: UserPageCriteria) {}
  }

  export class RefreshPage {
    static readonly type = `${prefix} Refresh page data`;

    constructor() {}
  }

  export class GetById {
    static readonly type = `${prefix} Get by id`;

    constructor(readonly id: number) {}
  }

  export class Create {
    static readonly type = `${prefix} Create`;

    constructor(readonly data: User) {}
  }

  export class Delete {
    static readonly type = `${prefix} Delete`;

    constructor(readonly id: number) {}
  }

  export class Edit {
    static readonly type = `${prefix} Edit`;

    constructor(
      readonly id: number,
      readonly data: User
    ) {}
  }

  export class InvalidateCache {
    static readonly type = `${prefix} Invalidate cache`;

    constructor(readonly id?: number) {}
  }
}
